// B-007 (ART-0166) — module dédié (et non ajouté à un fichier voisin) : cette route est
// publique (`permitAll`, `SecurityConfig` L79 côté gateway) et lisible SANS jeton, alors
// que tout le reste de `api/*Api.ts` suppose une session active — les mélanger aurait
// rendu cette frontière invisible à la lecture du code.
import { request } from './http'
import type { GatewayVersionInfo } from './types/version'

export const versionApi = {
  /** `GET /api/v1/public/version` — version/révision/date de construction de la passerelle. */
  gatewayVersion: () => request<GatewayVersionInfo>('/public/version'),
}
